import styled from 'styled-components';
import SpaSvg from '../../assets/amenities/spa.svg';

const SpaIcon = styled(SpaSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default SpaIcon;
